<template>
    <div>
        <kt-form-section>
            <div id="gateway_cards_div" style="margin-top: 40px">
                <div class="row" v-for="(cards,index) in card_to_card.bank_cards" v-bind:key="'gateway_cards'+index">
                    <form class="col-12" :id="'edit_gateway_card_form'+index">
                        <div class="row">
                            <div class="col-6">
                                <label
                                    for="bank_cards" style="font-size:small;margin-bottom: 15px;margin-top: 25px">
                                    {{ $t('card_to_card.card_details') }}{{ $t('ordinal_numbers.' + [index + 1]) }}
                                </label>
                            </div>
                            <div class="col-6" style="text-align: end">
                                <div style="display:inline-block;margin-top: 26px">
                                    <button
                                        type="button"
                                        @click="editGatewayCard(index)"
                                        class="btn btn-success px-4"
                                        style="border-radius: 10px"
                                        :id="'edit_gateway_card_btn'+index"
                                    >
                                        <span>ویرایش</span>
                                    </button>
                                </div>
                                <div style="display:inline-block;margin-top: 26px;margin-right: 5px">
                                    <button
                                        type="button"
                                        @click="removeGatewayCard(index)"
                                        class="btn btn-danger px-4"
                                        style="border-radius: 10px"
                                        :id="'remove_gateway_card_btn'+index"
                                    >
                                        <span>حذف</span>
                                    </button>
                                </div>
                            </div>
                            <kt-col lg="6" md="6" xs="12">
                                <kt-form-group style="position:relative;">
                                    <kt-form-label for="card_number">
                                        {{ $t('label.card_number') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        style="padding-left: 50px"
                                        dir="ltr"
                                        :id="'card_number'+ index"
                                        class="form-control"
                                        name="card_number"
                                        v-model="card_to_card.bank_cards[index].card_number"
                                    >
                                    </kt-form-control>
                                    <p style="position:absolute;left: 13px;top: 34px">603769</p>
                                </kt-form-group>
                                <p style="font-size: xx-small;color: red;">{{$t('card_to_card.message.only_saderat_is_supported')}}</p>
                            </kt-col>
                            <kt-col  lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="account_number">
                                        {{ $t('label.account_number') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        dir="ltr"
                                        :id="'account_number'+ index"
                                        class="form-control"
                                        name="account_number"
                                        v-model="card_to_card.bank_cards[index].account_number"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col  lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="first_name">
                                        {{ $t('card_to_card.card_owner_name') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        dir="rtl"
                                        :id="'card_owner_name'+ index"
                                        class="form-control"
                                        name="card_owner_name"
                                        v-model="card_to_card.bank_cards[index].card_owner_name"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col  lg="6" md="6" xs="12">
                                <kt-form-group>
                                    <kt-form-label for="bank_id">
                                        {{ $t('label.bank') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        dir="rtl"
                                        :id="'bank_id'+ index"
                                        disabled
                                        class="form-control"
                                        name="bank_id"
                                        value="صادرات"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </div>
                    </form>
                </div>
                <br>
                <label for="gateway_cards" style="font-size:small;margin-bottom: 15px;margin-top: 15px">
                    {{ $t('card_to_card.add_card') }}
                    <hr>
                </label>
                <form id="add_gateway_card_form">
                    <div class="row">
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group style="position:relative;">
                                <kt-form-label for="card_number">
                                    {{ $t('label.card_number') }}
                                </kt-form-label>
                                <kt-form-control
                                    style="padding-left: 50px"
                                    dir="ltr"
                                    id="card_number"
                                    class="form-control"
                                    name="card_number"
                                    v-model="new_card.card_number"
                                >
                                </kt-form-control>
                                <p style="position:absolute;left: 13px;top: 34px">603769</p>
                            </kt-form-group>
                            <p style="font-size: xx-small;color: red;">{{$t('card_to_card.message.only_saderat_is_supported')}}</p>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="account_number">
                                    {{ $t('label.account_number') }}
                                </kt-form-label>
                                <kt-form-control
                                    dir="ltr"
                                    id="account_number"
                                    class="form-control"
                                    name="account_number"
                                    v-model="new_card.account_number"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="card_owner_name">
                                    {{ $t('card_to_card.card_owner_name') }}
                                </kt-form-label>
                                <kt-form-control
                                    dir="rtl"
                                    id="card_owner_name"
                                    class="form-control"
                                    name="card_owner_name"
                                    v-model="new_card.card_owner_name"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="bank_id">
                                    {{ $t('label.bank') }}
                                </kt-form-label>
                                <kt-form-control
                                    dir="rtl"
                                    id="bank_id"
                                    disabled
                                    class="form-control"
                                    name="bank_id"
                                    value="صادرات"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <div style="display:inline-block;margin-top: 18px;padding-right: 20px">
                            <button
                                type="button"
                                @click="addGatewayCard()"
                                class="btn btn-success px-4"
                                style="border-radius: 10px"
                                id="add_gateway_card_btn"
                            >
                                <span>ثبت کارت</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </kt-form-section>
    </div>
</template>

<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import {cardToCardService} from "../../../common/api.service";
import {KTApp} from '@/plugins/core/app'
import {cardToCardStatus} from '@/constants/cardToCard'
import toastr from "toastr";

export default {
    components: {},
    props: {
        card_to_card: {
            default() {
                return {}
            },
            type: Object
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    data() {
        return {
            new_card: {},
            cardToCardStatus,
        }
    },
    mounted() {
        for (let i = 0; i < this.card_to_card.bank_cards.length; i++) {
            this.card_to_card.bank_cards[i].card_number = this.card_to_card.bank_cards[i].card_number.substring(6, 16)
        }
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        addGatewayCard() {
            if (this.card_to_card.bank_cards.length == 0)
                this.card_to_card.bank_cards = []
            let form = $('#add_gateway_card_form');
            let btn = $('#add_gateway_card_btn');

            form.validate({
                rules: {
                    card_number: {
                        required: true,
                    },
                    account_number: {
                        required: true,
                    },
                    card_owner_name: {
                        required: true,
                    }
                }
            });

            if (!form.valid()) {
                return;
            }
            for (var i = 0; i < this.card_to_card.bank_cards.length; i++) {
                if (this.card_to_card.bank_cards[i].card_number === this.new_card.card_number)
                    return this.toastr.error(i18n.t('card_to_card.message.card_number_is_duplicate'))
            }

            if (!this.validateCard('603769' + this.new_card.card_number))
                return this.toastr.error(i18n.t('card_to_card.message.card_number_is_not_valid'))

            KTApp.progress(btn);
            let params = {
                card_number: '603769' + this.new_card.card_number,
                account_number: this.new_card.account_number,
                card_owner_name: this.new_card.card_owner_name,
            }
            return cardToCardService.addBankCard(params, this.card_to_card.id).then(response => {
                this.new_card.id = response.data.data.id
                this.card_to_card.bank_cards.push(this.new_card)
                this.toastr.success(response.data.message)
                this.new_card = {}
                this.$store.dispatch('cardToCard/fetchSetting', this.card_to_card.id)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.toastr.error(response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        removeGatewayCard(index) {
            var result = confirm(i18n.t('card_to_card.message.remove_card_owner_alert'));
            if (!result) return;
            let btn = $('#remove_gateway_card_btn' + index);
            KTApp.progress(btn);
            return cardToCardService.deleteBankCard(this.card_to_card.bank_cards[index].id, this.card_to_card.id).then(response => {
                this.card_to_card.bank_cards.splice(index, 1)
                this.toastr.success(response.data.message)
                this.$store.dispatch('cardToCard/fetchSetting', this.card_to_card.id)
            }).catch(({response}) => {
                this.toastr.error(response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        editGatewayCard(index) {
            var result = confirm(i18n.t('card_to_card.message.edit_card_owner_alert'));
            if (!result) return;
            let form = $('#edit_gateway_card_form' + index)
            let btn = $('#edit_gateway_card_btn' + index);

            if (this.card_to_card.bank_cards.length == 0)
                this.card_to_card.bank_cards = []
            form.validate({
                rules: {
                    card_number: {
                        required: true,
                    },
                    account_number: {
                        required: true,
                    },
                    card_owner_name: {
                        required: true,
                    }
                }
            });

            if (!form.valid()) {
                return;
            }
            for (var i = 0; i < this.card_to_card.bank_cards.length; i++) {
                if (i != index && this.card_to_card.bank_cards[i].card_number === this.card_to_card.bank_cards[index].card_number)
                    return this.toastr.error(i18n.t('card_to_card.message.card_number_is_duplicate'))
            }

            if (!this.validateCard('603769' + this.card_to_card.bank_cards[index].card_number))
                return this.toastr.error(i18n.t('card_to_card.message.card_number_is_not_valid'))

            KTApp.progress(btn);

            let params = {
                card_number: '603769' + this.card_to_card.bank_cards[index].card_number,
                account_number: this.card_to_card.bank_cards[index].account_number,
                card_owner_name: this.card_to_card.bank_cards[index].card_owner_name,
            }
            return cardToCardService.editBankCard(this.card_to_card.bank_cards[index].id, this.card_to_card.id, params).then(response => {
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.toastr.error(response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        validateCard(code) {
            var l = code.length;
            if (l < 16 || parseInt(code.substr(1, 10), 10) == 0 || parseInt(code.substr(10, 6), 10) == 0) return false;
            var c = parseInt(code.substr(15, 1), 10);
            var s = 0;
            var k, d;
            for (var i = 0; i < 16; i++) {
                k = (i % 2 == 0) ? 2 : 1;
                d = parseInt(code.substr(i, 1), 10) * k;
                s += (d > 9) ? d - 9 : d;
            }
            return ((s % 10) == 0);
        },
        getBankName(index) {
            var number = this.card_to_card.bank_cards[index].card_number.substring(6, -16);
            if (number === '603799') {
                return 'بانک ملی'
            }
            if (number === '589210') {
                return 'بانک سپه'
            }
            if (number === '627961') {
                return 'بانک صنعت و معدن'
            }
            if (number === '603770') {
                return 'بانک کشاورزی'
            }
            if (number === '628023') {
                return 'بانک مسکن'
            }
            if (number === '627760') {
                return 'پست بانک ایران'
            }
            if (number === '502908') {
                return 'بانک توسعه تعاون'
            }
            if (number === '627412') {
                return 'بانک اقتصادنوین'
            }
            if (number === '622106') {
                return 'بانک پارسیان'
            }
            if (number === '502229') {
                return 'بانک پاسارگاد'
            }
            if (number === '627488') {
                return 'بانک کارآفرین'
            }
            if (number === '621986') {
                return 'بانک سامان'
            }
            if (number === '639346') {
                return 'بانک سینا'
            }
            if (number === '639607') {
                return 'بانک سرمایه'
            }
            if (number === '502806' || number === '504706') {
                return 'بانک شهر'
            }
            if (number === '502938') {
                return 'بانک دی'
            }
            if (number === '603769') {
                return 'بانک صادرات'
            }
            if (number === '610433') {
                return 'بانک ملت'
            }
            if (number === '627353' || number === '585983') {
                return 'بانک تجارت'
            }
            if (number === '589463') {
                return 'بانک رفاه'
            }
            if (number === '627381') {
                return 'بانک انصار'
            }
            if (number === '639599') {
                return 'بانک قوامین'
            }
            if (number === '504172') {
                return 'بانک رسالت'
            }
            if (number === '606373') {
                return 'بانک مهر ایران'
            }
            if (number === '636214') {
                return 'بانک آینده'
            }
            if (number === '505785') {
                return 'بانک ایران زمین'
            }
            if (number === '627648' || number === '207177') {
                return 'بانک توسعه صادرات ایران'
            }
            if (number === '636949') {
                return 'بانک حکمت ایرانیان'
            }
            if (number === '505416') {
                return 'بانک گردشگری'
            }
            if (number === '636795') {
                return 'بانک مرکزی'
            }
        }
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}

.preview_picture {
    width: 50%;
    height: 150px;
}

.remove_picture {
    cursor: pointer;
    position: absolute;
    top: -5px;
}
</style>